import React from 'react'

import style from './PageError.module.css'
import { LabsavvyIQLogo } from '@labsavvyapp/components'

export default function PageError({ message, children }) {
  return (
    <div className={style.container}>
      <LabsavvyIQLogo />
      <span className={style.message}>{message}</span>
      {children}
    </div>
  )
}
